import { render, staticRenderFns } from "./PrescriptionForm.vue?vue&type=template&id=d96d466e&scoped=true&"
import script from "./PrescriptionForm.vue?vue&type=script&lang=ts&"
export * from "./PrescriptionForm.vue?vue&type=script&lang=ts&"
import style0 from "./PrescriptionForm.vue?vue&type=style&index=0&id=d96d466e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d96d466e",
  null
  
)

export default component.exports